import { Img, Text, TextWithIcon } from "ui-kit/components-branded/index"
import { HelpTooltip } from "components"
import { TimeRequestSelectors } from "modules/Booking/common/interfaces"
import { sortDateAndTime } from "modules/Booking/common/utils"
import { formatToTotal } from "utils/datetime-format-utils"

interface TimeRequestInfoProps {
    requestTimesSelectors: TimeRequestSelectors[]
}

export function TimeRequestInfo({ requestTimesSelectors }: TimeRequestInfoProps) {
    return (
        <div className="mgb-4 is-flex is-align-content-center">
            <TextWithIcon
                icon={
                    <Img
                        className="booking-form-time-request-info__emoji"
                        src="check-mark-emoji.png"
                    />
                }
                position="left"
            >
                <Text className="booking-form-time-request-info__title">Вы&nbsp;выбрали время</Text>
            </TextWithIcon>
            <HelpTooltip
                placement="topLeft"
                className="booking-form-time-request-info__tooltip"
                overlay={
                    <div className="booking-form-time-request-info__tooltip-content">
                        <div> Сессия пройдет в&nbsp;один из&nbsp;следующих дней:</div>
                        {sortDateAndTime(requestTimesSelectors).map((item, index) => {
                            return (
                                <div key={index}>
                                    {item.date &&
                                        item.time &&
                                        formatToTotal(new Date(`${item.date} ${item.time}`))}
                                </div>
                            )
                        })}
                        <div className="mgt-2">
                            В&nbsp;течение 24&nbsp;часов мы&nbsp;сообщим вам какое время подтвердил
                            психолог.
                        </div>
                    </div>
                }
            />
        </div>
    )
}
